import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { Location } from '@angular/common';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'


@Component({
  selector: 'app-lunch-assignment',
  templateUrl: './lunch-assignment.component.html',
  styleUrls: ['./lunch-assignment.component.css']
})
export class LunchAssignmentComponent implements OnInit {
updatebutton=false;
submitbutton=true;
  lunchassignment=[];
  lunchForm:FormGroup;
  currentUser: User;
  username;
branch;
role;
success;
error;
branchCategories=[];
salesRepList=[];
date;
loggedInUserFullname;
loggedInUserBranch;
loggedInUserId;

  validationMessages = {
   
    'salesRep': {
      'required': 'required'
    },

    'branch': {
      'required': 'Branch is required'
    },
  
   
  };


  formErrors = {
 'salesRep': '',
    'branch': '',
    
  };
  constructor(private fb: FormBuilder,
    private router: Router,
    private _location: Location,
    private actroute: ActivatedRoute,
    private _authenticationService: AuthenticationService,
    public datepipe: DatePipe,
    private _appointment: AppointmentService,)
    {
      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
        this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
        this.branch=this.currentUser.branch;
        this.role=this.currentUser.role;


  
        this.loggedInUserFullname= this.username;
        this.loggedInUserBranch= this.branch
        this.loggedInUserId=this.currentUser.userName;
    
        
    
       }
    }

  ngOnInit(): void {
    this.getSalesRepForForm(this.loggedInUserBranch);
 
    //this.getBranchCategoriesForForm();
    
    //console.log(this._authenticationService.currentUserValue.userName)
    
     //actroute from tangibleasset
this.actroute.paramMap.subscribe(params => {
  // This is never executed, for route is not recognized
  // let myArray=params.getAll('extra');
  const pid = params.get('extra')
  const lunchTime = params.get('extra1')
  const salesRep = params.get('extra2')
  const branch = params.get('extra3');
  console.log(pid,lunchTime,salesRep,branch);
  if (pid) {
   
    this.getLunchToEdit(pid, salesRep,lunchTime,branch);
  //  this.viewMode = true;
  } else {
    //this.viewMode = false;
  //  console.log('done');
  }
});


    this.lunchForm = this.fb.group({
      actionPerformedBy:new FormControl(this._authenticationService.currentUserValue.userName),
      pid: new FormControl(''),
      branch: new FormControl(''),
      salesRep: new FormControl(''),
      lunchTime: new FormControl(''),
      

      //purchaseDate: new FormControl(''),
    });

    this.patchLunchTime();

    this.lunchForm.patchValue({
      branch:this.loggedInUserBranch
    });

    //error handling
    this.lunchForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.lunchForm);
    })
  }


  assignLunch(){
    this.logValidationErrors(this.lunchForm);
  
    this._appointment.assignLunchToSalesRep(this.lunchForm.value)
          .subscribe(//subscribe to Observable
            response => {
              console.log('Success!', response);
              this.success = response['SUCCESS'];
              this.lunchForm.reset;
              document.getElementById("openSuccessModalButton").click();
            },
            error => {
              console.error('ERROR!', error);
              this.error = error.error.text;
              document.getElementById("openErrorModalButton").click();
            }
          );  
  }

  getLunchToEdit(pid, salesRep,lunchTime,branch){
//console.log(pid,salesRep,lunchTime,branch);
    this._appointment.getLunchAssignment(pid,salesRep,lunchTime,branch).subscribe(
      response =>  {
        this.lunchassignment= response;

        console.log(this.lunchassignment);
        this.patchassignmentForm();
      },
      (err) => {
        this.error = err;
      }
    );
  }

  patchassignmentForm(){
    // this.branchselected = true;
    // this. getSalesRep(this.userappointment[0].branch);
     this.lunchForm.patchValue({
       // departmentId: assetformmodel[0].department,
        pid: this.lunchassignment[0].pid,
        branch: this.lunchassignment[0].branch,
        lunchTime: this.lunchassignment[0].timeIn,
        salesRep: this.lunchassignment[0].salesRep,
       

    
      });
      this.updatebutton=true;
      this.submitbutton=false;
   }


   deleteLunch(){
    this._appointment.deleteLunchAssignment(this.lunchForm.value)
    .subscribe(//subscribe to Observable
      response => {
        console.log('Success!', response);
        this.success = response['SUCCESS'];
        this.lunchForm.reset;
        document.getElementById("openSuccessDeleteModalButton").click();
      },
      error => {
        console.error('ERROR!', error);
        this.error = error.error.text;
        document.getElementById("openErrorDeleteModalButton").click();
      }
    );  
   }

  getSalesRepForForm(branch){
   // console.log(branch);
    if (branch != "None" || branch!="") {
      this._appointment.getSalesRepByBranch(branch).subscribe(
        (res) => {
          this.salesRepList = res;
        //  console.log(this.salesRepList);
        //  this.branchselected = true;
   
        }
        ,
        (err) => {
          this.error = err;
        }
      );
    }
  
  }


  patchLunchTime(){
    let dateTime = new Date();
    this.date=new Date();
let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

    this.lunchForm.patchValue({
      lunchTime:latest_date,
      branch:this.loggedInUserBranch
    });
  }



backClicked() {
  this._location.back();
}

  logValidationErrors(group: FormGroup ): void {
    //get the keys from FormGroup object and checks all the keys
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        //clear any previous error
        this.formErrors[key] = '';
        //check Validation of the formControl
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          //if not valid then get the error message of whatever the validation error is from the validationMessage method
          const messages = this.validationMessages[key];
          //for every error in validation get the error key and assign it to the formControl name is formError method
          for (const errorkey in abstractControl.errors) {
            if (errorkey) {
         //     console.log(key);

              this.formErrors[key] += messages[errorkey] + ''
            }
          }
        }
      }

    });
  }

  }


